/**
 * Estado inicial de una tarea
 */
export const INITIAL_TASK_STATE = {
  uuid: null,
  uuid_task_template: '',
  sequence_order: 1,
  name: '',
  description: '',
  phase: '',
  max_percentage: 0,
  default_percentage: 0,
  severity: 'low',
  is_active: true,
};

/**
 * Niveles de severidad disponibles
 */
export const SEVERITY_LEVELS = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};

/**
 * Opciones para el select de severidad
 */
export const SEVERITY_OPTIONS = [
  { value: SEVERITY_LEVELS.LOW, label: 'Baja' },
  { value: SEVERITY_LEVELS.MEDIUM, label: 'Media' },
  { value: SEVERITY_LEVELS.HIGH, label: 'Alta' },
];

/**
 * Etiquetas para mostrar severidad
 */
export const SEVERITY_LABELS = {
  [SEVERITY_LEVELS.LOW]: 'Baja',
  [SEVERITY_LEVELS.MEDIUM]: 'Media',
  [SEVERITY_LEVELS.HIGH]: 'Alta',
};

/**
 * Colores para los chips de severidad
 */
export const SEVERITY_COLORS = {
  [SEVERITY_LEVELS.LOW]: 'success',
  [SEVERITY_LEVELS.MEDIUM]: 'warning',
  [SEVERITY_LEVELS.HIGH]: 'error',
};

/**
 * Fases disponibles (basadas en el backend)
 */
export const PHASES = {
  PLANNING: 'planning',
  EXECUTION: 'execution',
  CONTROL: 'control',
  CLOSURE: 'closure',
};

/**
 * Opciones para el select de fases
 */
export const PHASE_OPTIONS = [
  { value: '', label: 'Sin fase específica' },
  { value: PHASES.PLANNING, label: 'Planificación' },
  { value: PHASES.EXECUTION, label: 'Ejecución' },
  { value: PHASES.CONTROL, label: 'Control' },
  { value: PHASES.CLOSURE, label: 'Cierre' },
];

/**
 * Etiquetas para mostrar fases
 */
export const PHASE_LABELS = {
  [PHASES.PLANNING]: 'Planificación',
  [PHASES.EXECUTION]: 'Ejecución',
  [PHASES.CONTROL]: 'Control',
  [PHASES.CLOSURE]: 'Cierre',
};

/**
 * Configuración de validaciones para tareas
 */
export const TASK_VALIDATION_RULES = {
  NAME: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 500,
  },
  DESCRIPTION: {
    MAX_LENGTH: 1000,
  },
  PERCENTAGE: {
    MIN: 0,
    MAX: 100,
  },
  SEQUENCE_ORDER: {
    MIN: 1,
  },
};

/**
 * Mensajes del sistema para tareas
 */
export const TASK_MESSAGES = {
  SUCCESS: {
    CREATE: 'Tarea creada exitosamente',
    UPDATE: 'Tarea actualizada exitosamente',
    DELETE: 'Tarea eliminada exitosamente',
    REORDER: 'Tareas reordenadas exitosamente',
  },
  ERROR: {
    CREATE: 'Error al crear la tarea',
    UPDATE: 'Error al actualizar la tarea',
    DELETE: 'Error al eliminar la tarea',
    REORDER: 'Error al reordenar las tareas',
    REQUIRED_FIELD: 'Este campo es obligatorio',
    NAME_TOO_SHORT: 'El nombre debe tener al menos 3 caracteres',
    NAME_TOO_LONG: 'El nombre no puede exceder 500 caracteres',
    DESCRIPTION_TOO_LONG: 'La descripción no puede exceder 1000 caracteres',
    INVALID_PERCENTAGE: 'El porcentaje debe estar entre 0 y 100',
    INVALID_SEQUENCE: 'El orden de secuencia debe ser mayor a 0',
    DUPLICATE_ORDER: 'Ya existe una tarea con este orden en la plantilla',
  },
  CONFIRMATION: {
    DELETE: '¿Está seguro que desea eliminar esta tarea?',
    REORDER: '¿Desea guardar el nuevo orden de las tareas?',
  },
};
